export default __webpack_public_path__ + "static/media/austin.a09a67f7.webp";